import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getLanguage, changeLocale } from 'actions';

const contains = (intl, messageId) => intl && intl.messages && !!intl.messages[messageId] && intl.messages[messageId] !== 'End-User License Agreement';

const LanguageSelector = ({ dispatch, intl, locale, languages, fullDictionaryLoaded }) => {
  const onLanguageChange = (language) => {
    dispatch(changeLocale(language, !fullDictionaryLoaded));
    if (fullDictionaryLoaded) {
      dispatch(getLanguage(language));
    }
  };

  const selector = languages && languages.length > 1 && <div className="language-selector">
    <label htmlFor="ddl-language" className="text-sm">
      { contains(intl, 'languageSelector.label') && intl.formatMessage({ id: 'languageSelector.label' }) }
      <select id="ddl-language" value={ locale } onChange={ event => onLanguageChange(event.target.value) }>
        { languages && languages.map(i => <option key={ i.key } value={ i.key } label={ i.value } lang={ i.key }>{ i.value }</option>) }
      </select>
    </label>
  </div>;

  return selector || null;
};

LanguageSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  intl: PropTypes.shape({
    messages: PropTypes.shape(),
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  fullDictionaryLoaded: PropTypes.bool.isRequired
};

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: {
      locale,
      fullDictionaryLoaded
    }
  } = state;

  return { locale, fullDictionaryLoaded };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(LanguageSelector));
